import workspaceQuery from '../../../graphql/queries/sales/TradeCounterTerminalsWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/TradeCounterTerminalsListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/TradeCounterTerminalsQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/TradeCounterTerminalsDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/TradeCounterTerminalsMutation.graphql';
import fragment from '../../../graphql/fragments/sales/TradeCounterTerminalsFragment.graphql';

const TradeCounterTerminal = {
  type: 'TradeCounterTerminal',
  title: 'Trade Counter Terminals',
  formTitle: 'Trade Counter Terminal',
  formUrl: '/Sales/TradeCounterTerminal/Details/',
  workspaceUrl: '/Sales/TradeCounterTerminal/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_TRADE_COUNTER_CONFIG',
};

export default TradeCounterTerminal;
